// Chiffrement réversible (obfuscation) des IDs pour les URLs.
// But : ne pas exposer le post_id brut dans l'URL des détails.
// Réversible côté client (XOR + base36 + préfixe 'k').
const SALT = 8675309

/** Encode un id numérique en jeton URL-safe non lisible (ex: 23 → "k4f9a"). */
export function encodeId(id) {
  const n = Number(id)
  if (!Number.isFinite(n) || n < 0) return String(id ?? '')
  const mixed = (n ^ SALT) >>> 0
  return 'k' + mixed.toString(36)
}

/** Décode un jeton vers l'id réel. Tolère un id brut (non encodé) → renvoyé tel quel. */
export function decodeId(token) {
  if (token == null) return token
  const s = String(token)
  if (s[0] !== 'k') return s // pas un jeton encodé → id brut, on le garde
  const mixed = parseInt(s.slice(1), 36)
  if (!Number.isFinite(mixed)) return s
  return String((mixed ^ SALT) >>> 0)
}
